import { FlashSaleCreate } from 'components/flash-sale/flash-sale-create/FlashSaleCreate'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { Alert } from 'avo-ui'
import {
    constructSelectedValue,
    convertErrorMessage,
    formatDateMoment,
    getSectionError,
    uploadFileToS3,
} from 'utils/utils'
import moment from 'moment/moment'
import { useFetch } from 'services/useFetch'
import { API_FLASH_SALE } from 'services/apiFlashSale'
import { SUBMIT_TYPE } from 'constants/constant'
import {
    INITIAL_STATE,
    GET_ITEM_FIELD_NAME,
    GET_FIELD_NAME,
    ITEM_FIELD_NAME_DETAIL,
    SECTION_FIELDS,
} from 'configs/flash-sale/configFormFlashSale'
import { useDispatch } from 'react-redux'
import { setUnSavedChangesData } from 'reducers/homeReducer'

export const FlashSaleCreateContainer = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [flashSaleDetail, setFlashSaleDetail] = useState({})
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [isDrafting, setIsDrafting] = useState(false)
    const [searchParams] = useSearchParams()
    const flashSaleId = searchParams.get('flashSaleId')
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getFlashSaleDetail, isLoading } = useFetch(API_FLASH_SALE.DETAIL)
    const { fetching: getUrlFlashSaleImages } = useFetch(API_FLASH_SALE.URL_FLASH_SALE_IMAGES)
    const { fetching: createFlashSale, isLoading: isCreating } = useFetch(API_FLASH_SALE.CREATE)
    const { fetching: updateFlashSale, isLoading: isUpdating } = useFetch(API_FLASH_SALE.UPDATE)
    const sectionRef = {
        general_data: useRef(),
        product_item: useRef(),
    }

    const checkIsFilledForm = () => {
        const copyFlashSale = { ...flashSaleDetail }
        let isValid = false
        const isExistProducts = () => {
            let isExist = false
            copyFlashSale?.products?.map((items) => {
                Object.keys(items).forEach((key) => {
                    if (items[key]) isExist = true
                })
            })
            return isExist
        }

        Object.keys(copyFlashSale).forEach((key) => {
            if ((copyFlashSale[key] && key !== 'products') || (key === 'products' && isExistProducts())) {
                isValid = true
            }
        })

        return isValid
    }

    useEffect(() => {
        dispatch(setUnSavedChangesData({ isFilledForm: checkIsFilledForm() }))
    }, [flashSaleDetail])

    const onChangeForm = (item) => {
        setFlashSaleDetail({ ...flashSaleDetail, ...item })
    }

    const setShowAlert = (message) => {
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const setUploadFlashSaleImages = async (type, filesName, uploadDetail) => {
        const newFlashSaleDetail = { ...flashSaleDetail }

        try {
            const s3Urls = await getUrlFlashSaleImages({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newFlashSaleDetail[uploadDetail[i]?.key] = `${item?.url}${item?.fields?.key}`
            })
            await Promise.all(apiS3list)
            onSave(type, newFlashSaleDetail)
        } catch (err) {
            console.log('upload failed')
            setIsDrafting(false)
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateProducts = () => {
            const result = []
            flashSaleDetail?.products?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]?.toString()) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const isInvalidTime = moment(flashSaleDetail?.date_expired)?.isSameOrBefore(
                moment(flashSaleDetail?.date_start),
            )
            const errors = {}
            Object.keys(flashSaleDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && (!flashSaleDetail[key] || flashSaleDetail[key]?.length === 0)) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (key === 'date_expired' && isInvalidTime) {
                    errors['time_expired'] = 'Jam berakhir tidak boleh kurang atau sama dengan jam mulai'
                } else if (key === 'products' && validateProducts()?.length) {
                    errors['products_detail'] = validateProducts()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = (type) => {
        validateForm().then(async () => {
            setIsDrafting(type === SUBMIT_TYPE?.DRAFT)
            const productImages = [
                flashSaleDetail?.image_url,
                flashSaleDetail?.desktop_image_url,
                flashSaleDetail?.mobile_image_url,
            ]
            const uploadDetail = []
            const filesName = []

            productImages.map((item) => {
                if (item?.name) {
                    filesName.push(item?.name?.replace(/\s/g, ''))
                    uploadDetail.push({ file: item?.file, key: item?.key })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadFlashSaleImages(type, filesName, uploadDetail)
            } else {
                onSave(type)
            }
        })
    }

    const onSave = (type, payload = { ...flashSaleDetail }) => {
        const newPayload = {
            ...payload,
            status: type?.toLowerCase(),
            date_start: payload?.date_start ? moment(payload?.date_start).utc().format('YYYY-MM-DD HH:mm') : null,
            date_expired: payload?.date_expired ? moment(payload?.date_expired).utc().format('YYYY-MM-DD HH:mm') : null,
            products: payload?.products?.map((item, index) => {
                return {
                    ...item,
                    product_id: item?.product_id?.value,
                    sequence: index,
                }
            }),
        }

        if (!flashSaleId) {
            createFlashSale(newPayload)
                .then(() => {
                    setShowAlert('Flash Sale Created !')
                    dispatch(setUnSavedChangesData({ isFilledForm: false }))
                    navigate('/flash-sale/flash-sale-list')
                })
                .catch((error) => {
                    setIsDrafting(false)
                    setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, ITEM_FIELD_NAME_DETAIL))
                })
        } else {
            updateFlashSale(newPayload, flashSaleId)
                .then(() => {
                    setShowAlert('Flash Sale Updated !')
                    dispatch(setUnSavedChangesData({ isFilledForm: false }))
                    navigate('/flash-sale/flash-sale-list')
                })
                .catch((error) => {
                    setIsDrafting(false)
                    setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, ITEM_FIELD_NAME_DETAIL))
                })
        }
    }

    useEffect(() => {
        const topSection = getSectionError(errorForm, SECTION_FIELDS)[0]
        sectionRef?.[topSection]?.current?.scrollIntoView({ behavior: 'smooth' })
    }, [errorForm])

    useEffect(() => {
        if (flashSaleId) {
            getFlashSaleDetail({}, flashSaleId).then((response) => {
                const { created_at, updated_at, ...data } = { ...response?.data }
                const newDetail = {
                    ...data,
                    date_start: data?.date_start ? formatDateMoment(data?.date_start, 'YYYY-MM-DD HH:mm') : null,
                    date_expired: data?.date_expired ? formatDateMoment(data?.date_expired, 'YYYY-MM-DD HH:mm') : null,
                    products: data?.products?.map((item) => {
                        const { flash_sale_id, product, ...newItem } = item
                        return {
                            ...newItem,
                            product_id: constructSelectedValue(product, 'name', 'id'),
                        }
                    }),
                }
                setFlashSaleDetail(newDetail)
            })
        } else {
            setFlashSaleDetail({
                ...INITIAL_STATE,
                products: [
                    {
                        product_id: null,
                        price: null,
                        stock_quantity: null,
                        limit_purchase: null,
                    },
                ],
            })
        }
        setErrorForm({})
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [flashSaleId])

    const props = {
        sectionProps: {
            sectionRef,
            flashSaleDetail,
            onChangeForm,
            errorForm,
        },
        isLoadingUpload,
        isLoading,
        isCreating,
        isUpdating,
        isDrafting,
        onSubmit,
    }

    return <FlashSaleCreate {...props} />
}
